import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import config from '@config';

import Button from '@views/Button';
import { acceptInvite } from '@service/ranking';
import { redirect } from 'redux-first-router';
import { actions as Pages } from '@pages/names';

import './RankingInvite.css';
import Link from 'redux-first-router-link';
import { INVITE_LOCALSTORAGE_KEY } from '../../actions/ranking';

export const RankingInvite = ({
  rankingId,
  name,
  participantsCount,
  notFound,
  participating,
  isLoggedIn,
  onAcceptInvite,
  onDeclineInvite,
}) => (
  <div className="RankingInvite">
    <div className="hero-bg">
      <img
        src={`${config.basePath}/img/copa-header.svg`}
        alt=""
        className="header-cup"
      />
      <div className="hero-content">
        <h2>Torneos de Amigos</h2>
        <p>Jugá con tus amigos</p>
      </div>
    </div>
    <div className="RankingInvite-container">
      {notFound ? (
        <div className="card ranking-not-found">
          <p>El torneo no existe o la invitación ha caducado</p>
          <Link to={['']}>
            <Button type="secondaray">Aceptar</Button>
          </Link>
        </div>
      ) : participantsCount >= config.maxParticipantsPerGroup ? (
        <div className="card ranking-not-found">
          <p>El torneo ya ha alcanzado su máximo de participantes</p>
          <Button type="secondaray" onClick={onDeclineInvite}>
            Aceptar
          </Button>
        </div>
      ) : (
        <div className="card">
          <h2>Te han invitado al torneo: {name}</h2>
          <p>
            <b>{participantsCount} personas ya están participando!</b>
          </p>

          {isLoggedIn ? (
            participating ? (
              <div>
                <p>Ya estás participando en este torneo!</p>
                <Link to={['rankings', rankingId]}>
                  <Button type="primary">Ir al torneo</Button>
                </Link>
              </div>
            ) : (
              <div>
                <Button type="primary" onClick={onAcceptInvite}>
                  Unirme al torneo
                </Button>
              </div>
            )
          ) : (
            <div>
              <p>
                Para poder aceptar la invitación, primero necesitás ingresar con
                tu usuario o crear uno nuevo!
              </p>
              <Link to={['acceder']}>
                <Button type="primary">Acceder</Button>
              </Link>
            </div>
          )}
        </div>
      )}
    </div>
  </div>
);

RankingInvite.displayName = 'RankingInvite';
RankingInvite.propTypes = {
  rankingId: PropTypes.string,
  name: PropTypes.string,
  participantsCount: PropTypes.number,
  participating: PropTypes.bool,
  notFound: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  onAcceptInvite: PropTypes.func,
  onDeclineInvite: PropTypes.func,
};

export const acceptGroupInvite = () => (dispatch, getState) => {
  let { jwToken, rankingInvite } = getState();
  return acceptInvite(jwToken, rankingInvite.inviteCode).then(() => {
    dispatch(
      redirect({
        type: Pages.RankingDetails,
        payload: { id: rankingInvite._id },
      })
    );
    dispatch({ type: 'RANKING_INVITE_CLEAR' });
    localStorage.removeItem(INVITE_LOCALSTORAGE_KEY);
  });
};

export const mapStateToProps = ({ rankingInvite, user }) => ({
  rankingId: rankingInvite?._id,
  name: rankingInvite?.name,
  participantsCount: rankingInvite?.participantsCount,
  participating: rankingInvite?.participating,
  notFound: rankingInvite?.notFound,
  isLoggedIn: !!user,
});

export const mapDispatchToProps = (dispatch) => ({
  onAcceptInvite: () => {
    dispatch(acceptGroupInvite());
  },
  onDeclineInvite: () => {
    dispatch(
      redirect({
        type: Pages.Home,
      })
    );
    dispatch({ type: 'RANKING_INVITE_CLEAR' });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RankingInvite);
